// CONSTANTS
import colors from 'constants/colors'

const badgesList = [
  {
    count: 2,
    color: colors.stackoverflowGold,
  },
  {
    count: 7,
    color: colors.stackoverflowSilver,
  },
  {
    count: 20,
    color: colors.stackoverflowBronze,
  },
]

export default badgesList